import { Construction, Wrench, HardHat } from "lucide-react";

export function MaintenancePage() {
  return (
    <div className="min-h-screen bg-[#121726] flex flex-col items-center justify-center relative overflow-hidden">
      {/* Construction stripes - top */}
      <div className="absolute top-0 left-0 right-0 h-8 bg-repeating-stripes" />
      <div className="absolute top-8 left-0 right-0 h-8 bg-repeating-stripes" style={{ animationDirection: "reverse" }} />

      {/* Construction stripes - bottom */}
      <div className="absolute bottom-8 left-0 right-0 h-8 bg-repeating-stripes" />
      <div className="absolute bottom-0 left-0 right-0 h-8 bg-repeating-stripes" style={{ animationDirection: "reverse" }} />

      {/* Content */}
      <div className="text-center px-6 max-w-lg z-10">
        <div className="flex items-center justify-center gap-3 mb-6">
          <HardHat className="w-12 h-12 text-[#F2EA77] animate-bounce" />
          <Construction className="w-16 h-16 text-[#F2EA77]" />
          <Wrench className="w-12 h-12 text-[#F2EA77] animate-bounce" style={{ animationDelay: "0.3s" }} />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-[#F2F2F2] mb-4" style={{ fontFamily: "Space Grotesk, sans-serif" }}>
          Pub<span className="text-[#F2EA77]">lee</span> em obras 🏗️
        </h1>

        <p className="text-[#F2DB94] text-lg md:text-xl mb-6 leading-relaxed">
          Estamos fazendo umas <strong>migrações importantes</strong>...
          <br />
          <span className="text-[#F2F2F2]/70 text-base">
            (não, não estamos mudando de país 🛫)
          </span>
        </p>

        <div className="bg-[#F2EA77]/10 border border-[#F2EA77]/20 rounded-2xl p-6 mb-8 backdrop-blur-sm">
          <p className="text-[#F2F2F2]/90 text-sm md:text-base leading-relaxed">
            Nosso time está trabalhando nos bastidores
            <br />
            para deixar tudo mais rápido, estável e robusto.
            <br />
            <br />
            <span className="text-[#F2EA77] font-semibold">
              Previsão de retorno: 20/03
            </span>
            <br />
            <span className="text-[#F2F2F2]/50 text-xs">(sim, dessa vez a gente colocou uma data real no deploy)</span>
          </p>
        </div>

        <a
          href="mailto:suporte@publee.art"
          className="text-[#F2DB94] hover:text-[#F2EA77] text-sm transition-colors underline underline-offset-4"
        >
          Dúvidas? suporte@publee.art
        </a>
      </div>

      <style>{`
        .bg-repeating-stripes {
          background: repeating-linear-gradient(
            45deg,
            #F2EA77,
            #F2EA77 20px,
            #121726 20px,
            #121726 40px
          );
          animation: stripe-move 2s linear infinite;
        }

        @keyframes stripe-move {
          0% { background-position: 0 0; }
          100% { background-position: 56px 0; }
        }
      `}</style>
    </div>
  );
}
